import * as ActionTypes from '../actions/EMSUsageReports';

const initialState = {
  incidentReports: [],
  incidentReportsPage: 0,
  incidentReportsPages: 0,
  incidentReportsTotalElements: 0,
  incidentReportsInitialPage: 0,
  incidentReportsPageSize: 100,
  tableFilter: '',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.GET_INCIDENT_REPORTS.SUCCESS:
      return {
        ...state,
        incidentReports: action.payload.content,
        incidentReportsPage: action.payload.currentPage,
        incidentReportsPages: action.payload.totalPages,
        incidentReportsTotalElements: action.payload.totalElements,
      };
    case ActionTypes.SET_INCIDENT_REPORTS_PAGE:
      return { ...state, incidentReportsPage: action.payload };
    case ActionTypes.SET_INCIDENT_REPORTS_PAGE_SIZE:
      return { ...state, incidentReportsPageSize: action.payload };
    case ActionTypes.SET_INCIDENT_REPORTS_TABLE_FILTER:
      return { ...state, tableFilter: action.payload };
    default:
      return state;
  }
}
